export default "__VITE_ASSET__CxX88Cb2__"